<template>
  <v-text-field
    v-model="model"
    v-bind="$attrs"
    hint="Dạng dd/mm/yyyy"
    persistent-hint
    :rules="c_rules"
    @click:clear="$emit('click:clear')"
    @input="onChangeValue"
  >
    <template v-for="slot in $slots" v-slot:[slot]>
      <slot :name="slot" />
    </template>
    <template #append>
      <slot name="append" />
    </template>
  </v-text-field>
</template>

<script>
import moment from 'moment'
let FORMAT_INPUT = 'DD/MM/YYYY'
export default {
  props: {
    value: {},
    rules: { type: Array, default: () => [] },
    formatValue: {
      type: String,
      default: 'DD/MM/YYYY',
    },
  },
  data: () => ({ model: '' }),
  computed: {
    c_rules() {
      return [
        (v) => {
          if (v && !moment(v, FORMAT_INPUT, true).isValid())
            return 'Ngày không hợp lệ'
          return true
        },
        ...this.rules,
      ]
    },
    isValid() {
      return !this.model || moment(this.model, FORMAT_INPUT, true).isValid()
    },
  },
  watch: {
    value: {
      handler(value) {
        this.model = ''
        try {
          if (!value) {
            return
          }
          if (moment(value, this.formatValue, true).isValid()) {
            this.model = moment(value, this.formatValue).format(FORMAT_INPUT)
          }
        } catch (error) {
          console.error(error)
          this.model = ''
        }
      },
      immediate: true,
    },
  },
  methods: {
    onChangeValue(value) {
      if (!this.isValid) return
      this.$emit(
        'input',
        moment(this.model, FORMAT_INPUT, true).format(this.formatValue)
      )
    },
  },
}
</script>

<style scoped></style>
